export default __webpack_public_path__ + "static/media/repute1.157e550b.jpg";